export const SEARCH_KEYWORDS = 'SEARCH_KEYWORDS';
export const SEARCH_MOVIES = 'SEARCH_MOVIES';
export const FETCH_MOVIES_KEYWORDS = 'FETCH_MOVIES_KEYWORDS';
export const FETCH_MOVIE_INFO = 'FETCH_MOVIE_INFO';